(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["d2c-ingredients-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    function initD2cIngredientsPopup(root) {
      if (root.hasAttribute('data-d2c-ingredients-init')) return;
      root.setAttribute('data-d2c-ingredients-init', '');

      const openBtn = root.querySelector('[data-d2c-ingredients-open]');
      const modal = root.querySelector('[data-d2c-ingredients-modal]');
      if (!openBtn || !modal) return;

      const panel = modal.querySelector('.d2c-ingredients-popup__modal-panel');
      const closers = modal.querySelectorAll('[data-d2c-ingredients-close]');
      let prevBodyOverflow = '';

      function setOpen(isOpen) {
        if (isOpen) {
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          prevBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          if (panel) {
            try {
              panel.focus();
            } catch (e) {}
          }
        } else {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = prevBodyOverflow;
        }
      }

      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(true);
      });

      closers.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          setOpen(false);
          try {
            openBtn.focus();
          } catch (err) {}
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (!root.contains(modal) || modal.getAttribute('aria-hidden') === 'true') return;
        e.preventDefault();
        setOpen(false);
        try {
          openBtn.focus();
        } catch (err) {}
      });
    }

    document.querySelectorAll('[data-d2c-ingredients-popup]').forEach(initD2cIngredientsPopup);
  })();
  } catch(e) { console.error(e); }
})();

})();
